import { HostOs, HostPlatform } from '@ftr/contracts/regional-api'
import { AbstractClassBuilder, assertUnreachable } from '@ftr/foundation'

const macHost: HostOs = {
  arch: 'x64',
  codename: 'macOs Sonoma',
  distro: 'macos',
  kernel: '23.4.0',
  platform: HostPlatform.Darwin,
  release: '14.1',
  servicePack: '',
  version: '23E5196e',
}

const windowsHost: HostOs = {
  arch: 'x64',
  codename: '',
  distro: 'Microsoft Windows 11 Pro',
  kernel: '10.0.22621',
  platform: HostPlatform.Windows,
  release: '10.0.22621',
  servicePack: '0.0',
  version: '22621',
}

const linuxHost: HostOs = {
  arch: 'x64',
  codename: 'jammy',
  distro: 'Ubuntu',
  kernel: '5.15.133.1-microsoft-standard-WSL2',
  platform: HostPlatform.Linux,
  release: '22.04.4 LTS',
  servicePack: '',
  version: '',
}

export function getOsSpecificHostOs(platform: HostPlatform): HostOs {
  switch (platform) {
    case HostPlatform.AIX:
    case HostPlatform.Android:
    case HostPlatform.FreeBSD:
    case HostPlatform.Haiku:
    case HostPlatform.OpenBSD:
    case HostPlatform.SunOS:
    case HostPlatform.Cygwin:
    case HostPlatform.NetBSD:
    case HostPlatform.Linux:
      return linuxHost
    case HostPlatform.Darwin:
      return macHost
    case HostPlatform.Windows:
      return windowsHost
    default:
      assertUnreachable(platform)
  }
}

export class HostOsBuilder extends AbstractClassBuilder<HostOs> {
  constructor(platform: HostPlatform) {
    super(HostOs, getOsSpecificHostOs(platform))
  }
}
